import { render, staticRenderFns } from "./until-winning.vue?vue&type=template&id=21232621&scoped=true&"
import script from "./until-winning.vue?vue&type=script&lang=js&"
export * from "./until-winning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21232621",
  null
  
)

export default component.exports